<script>
  const { fillColor = "#000" } = $props();

</script>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1560_10303)">
<path d="M11.7401 6.84853L3.91309 1.95703V16.633L11.7401 21.5245L19.5671 16.633V1.95703L11.7401 6.84853ZM11.7401 19.5685L5.86309 15.907V5.25703L11.7401 8.80603V19.5685Z" fill={fillColor}/>
</g>
<defs>
<clipPath id="clip0_1560_10303">
  <rect width="24" height="24" fill="white" />
</clipPath>
</defs>
</svg>
